import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CompanyApplyJob extends Component {
  constructor(props) {
    super(props);

    this.targetDomain = 'https://boards.greenhouse.io';
    this.boardURL = `${this.targetDomain}/embed/job_app?for=${this.props.for}&token=${this.props.id}`;
    this.state = {
      height: 2461,
    };
    this.windowResize = this.windowResize.bind(this);
    this.resizeBoard = this.resizeBoard.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.resizeBoard);
    window.addEventListener('resize', this.windowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.resizeBoard);
    window.removeEventListener('resize', this.windowResize);
  }

  windowResize() {
    if (window.postMessage && this.boardElement) {
      this.boardElement.contentWindow.postMessage('resize', this.targetDomain);
    }
  }

  resizeBoard(evt) {
    const isGreenhouse = evt.origin === this.targetDomain;
    const heightIsValid = evt.data > 0 && evt.data !== this.state.height;

    if (this.boardElement && isGreenhouse && heightIsValid) {
      this.setState({ height: evt.data });
    }
  }

  /* eslint-disable jsx-a11y/iframe-has-title */
  render() {
    return (
      <iframe
        ref={(element) => {
          this.boardElement = element;
        }}
        src={this.boardURL}
        height={this.state.height}
        width="100%"
        style={{ border: 'none' }}
        onLoad={this.windowResize}
        sandbox="allow-same-origin allow-scripts allow-forms"
      />
    );
  }
  /* eslint-enable jsx-a11y/iframe-has-title */
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompanyApplyJob.propTypes = {
  id: PropTypes.number.isRequired,
  for: PropTypes.string.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompanyApplyJob.defaultProps = {
  for: 'nerdwallet', // eslint-disable-line react/default-props-match-prop-types
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompanyApplyJob.displayName = 'Company Apply Job';

export default CompanyApplyJob;
